import React, { useState } from "react";
import ExcelJS from "exceljs";
import saveAs from "file-saver";
import Dropdown from "react-bootstrap/Dropdown";

import { listCreateOrderOfBillings as  billingListApi } from "../../graphql/queries";
import fetchItemsNextToken from "../../function/fetchItemsNextTokenZau";

import {
  Select,
  DatePicker,
  Button,
  Card,
  Row,
  Col,
  Divider,
  List  
} from "antd";

import "antd/dist/antd.css";

const { Option } = Select;
const { RangePicker } = DatePicker;

const LocationalReport = (props) => {
  
  const [searchData, setSearchData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("0");
  const [typeofReport, setTypeofReport] = useState("");
  const [loading, setLoading] = useState(false);

  const handleOptionChange = (value) => setSelectedOption(value);


  const handleDateRangeChange = (value) => {
    setTypeofReport(value)
  };

  async function handleExportExcel() {
      // Create a new workbook and a new worksheet
    setLoading(true);
     try {

      let queryData = {
        query: billingListApi,
            variables: {
                filter: {
                    isDeleted: { ne: "1" },
                    or: [{ ownedBy: { eq: "14e6140b-c783-44a2-8248-6d2e6495fb74" }}, { ownedBy: { eq: "9efdb005-00f2-4157-be68-379604b514a6" }}],
                },
                limit: 1000,
            },
      }

      const response  = await fetchItemsNextToken(queryData);

      let new_result = response.filter(item => new Date(item.createdAt).getFullYear() === Number(selectedOption));

      const response_reduce = new_result.filter((item) => item.status === "3" || item.status === "4" || item.status === "5" || item.status === "6").reduce((acc, item) => {
        const { 
          application_no, 
          owner, 
          project_activity, 
          createdAt, 
          updatedAt, 
          OrDate, 
          OrNumber, 
          opStatusDate1: dateForwaredToRecommendation,
          signatureDate1: marlonSignatureDate,
          signatureDate2:chiefSignatureDate, 
          order_payment_no,
          isGovementInstitution,
          isNoPaymenItem,
          status,
          grandTotal,
        } = item;
        acc.push({ 
          application_no, 
          owner, 
          project_activity, 
          createdAt, 
          updatedAt, 
          OrDate, 
          OrNumber, 
          dateForwaredToRecommendation,
          chiefSignatureDate,
          marlonSignatureDate,
          order_payment_no,
          isGovementInstitution,
          isNoPaymenItem,
          status,
          grandTotal
        });
        return acc;
      },[])

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Completed");
      const worksheetOngoing = workbook.addWorksheet("Ongoing and Denied");

      const headers = [
        { header: "Applicant No",  width: 30 },
        { header: "Owner",  width: 30 },
        { header: "Project Activity",width: 30 },
        { header: "Date of Application", width: 30 },
        { header: "Billing No", width: 40 },
        { header: "OR NO", width: 40 },
        { header: "Status", width: 30 },
        { header: "Date forwarded for recommendation", width: 50 },
        { header: "Date Recommended", width: 30 },
        { header: "Date Approved", width: 30 },
        { header: "Date Billed", width: 30 },
        { header: "Amount", width: 30 },
        { header: "Date Paid", width: 30 },
      ];

      let datarow = worksheet.getRow(1);

      // Set headers
      headers.forEach((header, index) => {
        let cell = datarow.getCell(index + 1);
        cell.value = header.header;
        cell.alignment = { vertical: "middle", horizontal: "center" };
        worksheet.getColumn(index + 1).width = header.width;
      });

      // Define border style
      const borderStyle = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

    // Add border to all cells and adjust row height for spacing
    worksheet.eachRow((row, rowNumber) => {
      row.height = 20; // adjust as needed
      if (rowNumber >= 1) {
        row.height = 20; // Adjust as needed
        row.eachCell((cell) => {
          cell.border = borderStyle;
        });
      }
    });
    
    let rowIndex = 2;

    for (let i = 0; i < response_reduce.length; i++) {
      const item = response_reduce[i];
      
      let dataRow = worksheet.getRow(rowIndex);

      dataRow.eachCell((cell) => {
        cell.alignment = { wrapText: true };
      });

      dataRow.getCell(1).value = item.application_no;
      dataRow.getCell(1).alignment = { wrapText: true };

      dataRow.getCell(2).value = item.owner;
      dataRow.getCell(2).alignment = { wrapText: true };

      dataRow.getCell(3).value = item.project_activity;
      dataRow.getCell(3).alignment = { wrapText: true };

      dataRow.getCell(4).value = new Date(item.createdAt).toISOString().split('T')[0];
      dataRow.getCell(4).alignment = { wrapText: true };

      dataRow.getCell(5).value = item.order_payment_no;
      dataRow.getCell(5).alignment = { wrapText: true };

      dataRow.getCell(6).value = item.OrNumber;
      dataRow.getCell(6).alignment = { wrapText: true };

      dataRow.getCell(7).value = item.status === "5" ? "Paid" : (item.status === "6" && item.isGovementInstitution) ? "Goverment" : (item.status === "6" && item.isNoPaymenItem) ? "Ammended" : "Not Yet Paid";
      dataRow.getCell(7).alignment = { wrapText: true };

      dataRow.getCell(8).value =  new Date(item.dateForwaredToRecommendation).toISOString().split('T')[0];
      dataRow.getCell(8).alignment = { wrapText: true };

      dataRow.getCell(9).value =  new Date(item.marlonSignatureDate).toISOString().split('T')[0];
      dataRow.getCell(9).alignment = { wrapText: true };

      dataRow.getCell(10).value =  new Date(item.chiefSignatureDate).toISOString().split('T')[0];
      dataRow.getCell(10).alignment = { wrapText: true };

      dataRow.getCell(11).value =  new Date(item.chiefSignatureDate).toISOString().split('T')[0];
      dataRow.getCell(11).alignment = { wrapText: true };

      dataRow.getCell(12).value = item.grandTotal ? parseFloat(item.grandTotal).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "0";
      dataRow.getCell(12).alignment = { wrapText: true };

      dataRow.getCell(13).value = item.isGovementInstitution ? "-" : item.isNoPaymenItem ? "-" : item.OrDate !== "0" ? new Date(item.OrDate).toISOString().split('T')[0]: "-";
      dataRow.getCell(13).alignment = { wrapText: true };


      dataRow.eachCell((cell) => {
        cell.border = borderStyle;
      });

      rowIndex++;

    }

    const response_reduce_ongoing = new_result.filter((item) => item.status === "1" || item.status === "2" || item.status === "15").reduce((acc, item) => {
      const { 
        application_no, 
        owner, 
        project_activity, 
        createdAt, 
        updatedAt, 
        OrDate, 
        OrNumber, 
        opStatusDate1: dateForwaredToRecommendation,
        signatureDate1: marlonSignatureDate,
        signatureDate2:chiefSignatureDate, 
        order_payment_no,
        isGovementInstitution,
        isNoPaymenItem,
        status,
        grandTotal
      } = item;
      acc.push({ 
        application_no, 
        owner, 
        project_activity, 
        createdAt, 
        updatedAt, 
        OrDate, 
        OrNumber, 
        dateForwaredToRecommendation,
        chiefSignatureDate,
        marlonSignatureDate,
        order_payment_no,
        isGovementInstitution,
        isNoPaymenItem,
        status,
        grandTotal
      });
      return acc;
    },[])

    let datarowOngoing = worksheetOngoing.getRow(1);

    headers.forEach((header, index) => {
      let cell = datarowOngoing.getCell(index + 1);
      cell.value = header.header;
      cell.alignment = { vertical: "middle", horizontal: "center" };
      worksheetOngoing.getColumn(index + 1).width = header.width;
    });

    // Add border to all cells in the Ongoing worksheet
    worksheetOngoing.eachRow((row, rowNumber) => {
      row.height = 20; // adjust as needed
      if (rowNumber >= 1) {
        row.height = 20; // Adjust as needed
        row.eachCell((cell) => {
          cell.border = borderStyle;
        });
      }
    });

    // Add data to the Ongoing worksheet
    let rowIndexOngoing = 2;
    for (let i = 0; i < response_reduce_ongoing.length; i++) {
      const item = response_reduce_ongoing[i];
      
      let dataRow = worksheetOngoing.getRow(rowIndexOngoing);

      dataRow.eachCell((cell) => {
        cell.alignment = { wrapText: true };
      });

      dataRow.getCell(1).value = item.application_no;
      dataRow.getCell(1).alignment = { wrapText: true };

      dataRow.getCell(2).value = item.owner;
      dataRow.getCell(2).alignment = { wrapText: true };

      dataRow.getCell(3).value = item.project_activity;
      dataRow.getCell(3).alignment = { wrapText: true };

      dataRow.getCell(4).value = new Date(item.createdAt).toISOString().split('T')[0];
      dataRow.getCell(4).alignment = { wrapText: true };

      dataRow.getCell(5).value = item.order_payment_no || "-";
      dataRow.getCell(5).alignment = { wrapText: true };

      dataRow.getCell(6).value = item.OrNumber || "-";
      dataRow.getCell(6).alignment = { wrapText: true };

      dataRow.getCell(7).value = item.status === "15" ? `Denied` : "Ongoing";
      dataRow.getCell(7).alignment = { wrapText: true };

      dataRow.getCell(8).value =  new Date(item.dateForwaredToRecommendation).toISOString().split('T')[0];
      dataRow.getCell(8).alignment = { wrapText: true };

      dataRow.getCell(9).value =  item.marlonSignatureDate ? new Date(item.marlonSignatureDate).toISOString().split('T')[0] : "";
      dataRow.getCell(9).alignment = { wrapText: true };

      dataRow.getCell(10).value =  item.chiefSignatureDate ? new Date(item.chiefSignatureDate).toISOString().split('T')[0] : "";
      dataRow.getCell(10).alignment = { wrapText: true };

      dataRow.getCell(11).value =  item.chiefSignatureDate ? new Date(item.chiefSignatureDate).toISOString().split('T')[0]: "0";
      dataRow.getCell(11).alignment = { wrapText: true };

      dataRow.getCell(12).value = item.grandTotal ? parseFloat(item.grandTotal).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : "0";
      dataRow.getCell(12).alignment = { wrapText: true };


      dataRow.getCell(13).value = item.isGovementInstitution ? "-" : item.isNoPaymenItem ? "-" : item.OrDate === "0" ? "-" : "-";
      dataRow.getCell(13).alignment = { wrapText: true };

     
      

      dataRow.eachCell((cell) => {
        cell.border = borderStyle;
      });

      rowIndexOngoing++;
    }
    


    workbook.xlsx
      .writeBuffer()
      .then((buffer) => {
        const blob = new Blob([buffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(blob, `Report_${Number(selectedOption)}.xlsx`);
      })
      .catch((error) => {
        console.error("Error during Excel file generation:", error);
      });
    } catch (error) {
        console.log("Something went wrong", error)
    } finally {
      setLoading(false);
    }
  }


  // const handleGenerateReport = async () => {
  //   try {
  //     let queryData;
  //     if (selectedOption === "1") {
  //        if(props.role === "admin") {
  //           queryData = {
  //             query: listCreateOrderOfBillings,
  //             variables: {
  //               filter: {
  //                 order_payment_no: { ne: "0" },
  //                 OrNumber: { eq: "0" },
  //                 isDeleted: { ne: "1" },
  //               },
  //               limit: 1000,
  //             },
  //           };
  //        } else {
  //           queryData = {
  //             query: listCreateOrderOfBillings,
  //             variables: {
  //               filter: {
  //                 order_payment_no: { ne: "0" },
  //                 OrNumber: { eq: "0" },
  //                 isDeleted: { ne: "1" },
  //                 ownedBy: { eq: props.ownerId },
  //               },
  //               limit: 1000,
  //             },
  //           };
  //        }
   
  //     } else if (selectedOption === "2") {
  //         if(props.role === "admin") {
  //             queryData = {
  //               query: listCreateOrderOfBillings,
  //               variables: {
  //                 filter: {
  //                   status:{ eq:"5" },
  //                   isDeleted: { ne: "1" },
  //                 },
  //                 limit: 1000,
  //               },
  //             };
  //         } else {
  //             queryData = {
  //               query: listCreateOrderOfBillings,
  //               variables: {
  //                 filter: {
  //                   status:{ eq:"5" },
  //                   isDeleted: { ne: "1" },
  //                   ownedBy: { eq: props.ownerId },
  //                 },
  //                 limit: 1000,
  //               },
  //             };
  //         }
  //     } else {
  //       Swal.fire("Please select an option", "", "warning").then(() => {
  //         setSearchData([]);
  //       });
  //     }

  //     const a = fetchItemsNextToken(queryData);
  //     a.then(async (response) => {
  //       console.log(response);
  //       if (response.length > 0) {
  //         let date_array = [];
  //         let r = [];
  //         date_array.push(selectedDateRange);
  //         date_array.forEach((itemDate) => {
  //           itemDate.forEach((item) => {
  //             let n = new Date(item["_d"]);
  //             r.push(n.toISOString());
  //           });
  //         });
  //         if (r.length > 0) {
  //           const f = response.filter((item) => {
  //             const date = new Date(item.createdAt);
  //             return date >= new Date(r[0]) && date <= new Date(r[1]);
  //           });
  //           setSearchData(f);
  //         } else {
  //           setSearchData(
  //             response.sort(
  //               (a, b) => new Date(b.createAt) - new Date(a.createAt)
  //             )
  //           );
  //         }
  //       } else {
  //         Swal.fire("No Data Found", "", "info").then(() => {
  //           setSearchData([]);
  //         });
  //       }
  //     });
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
   
 
  // const handleExportExcel = () => {
  //   try {
      
  //     const toDownload = searchData.map((obj) => {

  //       const {
  //         owner,
  //         createdAt,
  //         order_payment_no,
  //         grandTotal,
  //         OrNumber,
  //         OrDate,
  //         signatureDate2,
  //         Payitem
  //       } = obj;

  //       return {
  //         "OWNER": owner.toUpperCase(),
  //         "BILLING NUMBER": order_payment_no,
  //         "OR NUMBER": OrNumber === "0" ? "" : OrNumber,
  //         "OR DATE":
  //           OrDate === "0"
  //             ? ""
  //             : new Date(OrDate).toLocaleString("en-US", {
  //                 minimumFractionDigits: 2,
  //                 maximumFractionDigits: 2,
  //               }),
  //         "GRAND TOTAL": grandTotal,
  //         "PAYITEM" :Payitem,
  //         "Date Approved":signatureDate2,
  //         "Date Created ": new Date(createdAt).toLocaleString("en-US", {
  //           minimumFractionDigits: 2,
  //           maximumFractionDigits: 2,
  //         }),
  //       };
  //     });

  //     let data = [
  //       {
  //         sheet: "ZAU ORDER OF PAYMENT",
  //         columns: [
  //           { label: "OWNER", value: "OWNER" },
  //           { label: "BILLING NUMBER", value: "BILLING NUMBER" },
  //           { label: "OR NUMBER", value: "OR NUMBER" },
  //           { label: "OR DATE", value: "OR DATE" },
  //           { label: "GRAND TOTAL", value: "GRAND TOTAL" },
  //           { label: "Date Approved", value: "Date Approved" },
  //           { label: "PayItem", value: "PAYITEM" },
  //           { label: "Date Created ", value: "Date Created " },
  //         ],
  //         content: toDownload.sort(
  //           (a, b) =>
  //             new Date(b["Date Created "]) - new Date(a["Date Created "])
  //         ),
  //       },
  //     ];

  //     let settings = {
  //       fileName: "APPROVED APPLICATIONS",
  //       extraLength: 4,
  //     };

  //     let afterDownload = function () {
  //       notification["success"]({
  //         message: "Success",
  //         description: "Excel file downloaded.",
  //       });
  //     };

  //     xlsx(data, settings, afterDownload);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };
 
  const handleGenerateReport = async () => {

    if(typeofReport === "SZAB" && selectedOption !== "0") {
        let url;
        let title;
    
        url = "/print-report?year=" + selectedOption;
        title = "Report";
        const params =
          "directories=no,titlebar=no,toolbar=no,location=off," +
          "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";
    
        window.open(url, title, params);
    } else if(typeofReport === "GR") {
      handleExportExcel();
    }
  
  };

  // const handleExportExcel = () => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("My Sheet");

  //   workbook.xlsx
  //   .writeBuffer()
  //   .then((buffer) => {
  //     const blob = new Blob([buffer], {
  //       type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     });
  //     saveAs(blob, `test.xlsx`);
  //   })
  //   .catch((error) => {
  //     console.error("Error during Excel file generation:", error);
  //   });

  // };


  const handlePrintLCForm = (id) => {
    let url;
    let title;
    url = "/lc-form-print?id=" + id;
    title = "Locational Form";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const handlePrintOrderOfPayment = (id) => {
    let url;
    let title;
    url = "/orderofpaymentzau-form-print?id=" + id;
    title = "Order of Payment ";
    const params =
      "directories=no,titlebar=no,toolbar=no,location=off," +
      "status=no,menubar=no,scrollbars=no,resizable=no,width=800,height=800";

    window.open(url, title, params);
  };

  const columns = [
    {
      title: "Application No",
      dataIndex: "application_no",
      key: "application_no",
      width: 125,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.application_no}
        </span>
      ),
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      width: 130,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.owner}
        </span>
      ),
    },
    {
      title: "Project Activity",
      dataIndex: "project_activity",
      key: "project_activity",
      width: 450,
      align: "center",
      render: (text, record) => (
        <span style={{ fontSize: "16px", fontWeight: "normal" }}>
          {record.project_activity}
        </span>
      ),
    },

    {
      title: "",
      key: "action",
      width: 180,
      align: "center",
      render: (text, record) => (
        <div style={{ display: "block" }}>
          {record.Signature1 === "1" && record.Signature2 === "1" && (
            <Dropdown>
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                style={{ fontWeight: "bold", marginTop: "10px" }}
              >
                Print
              </Dropdown.Toggle>
              <Dropdown.Menu style={{ margin: 0 }}>
                <Dropdown.Item
                  onClick={() => handlePrintLCForm(record.id)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Locational Clearance
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => handlePrintOrderOfPayment(record.id)}
                  target="_blank"
                  rel="noreferrer"
                >
                  Order of Payment
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          )}
        </div>
      ),
    },
  ];


  return (
    <div className="page-container" style={{ height: '100%' }}>
      {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#333",
              }}
            >
              Generating...
            </div>
          </div>
      )}
      <List>
        <Card>
          <Row gutter={[16, 16]} style={{marginBottom:"50px"}}>
            <Col xs={24}>
              <h2>Reports</h2>
              <Divider />
            </Col>
            <Col xs={24} md={8}>
              <Select
                placeholder="Select an option"
                onChange={handleOptionChange}
                value={selectedOption}
                style={{ width: "100%" }}
              > 
                <Option value="0">-</Option>
                <Option value="2023">2023</Option>
                <Option value="2024">2024</Option>
              </Select>
            </Col>
            <Col xs={24} md={8}>
              <Select
                placeholder="Select an option"
                onChange={handleDateRangeChange}
                value={typeofReport}
                style={{ width: "100%" }}
              > 
                <Option value="0">-</Option>
                <Option value="SZAB">Status of Zoning Applications Building Permit Purposes</Option>
                <Option value="GR">General Report</Option>
              </Select>
            </Col>
            <Col xs={24} md={8}>
              <Button 
                onClick={handleGenerateReport} 
              >
                  Generate Report
              </Button>
            </Col>
          </Row>
        </Card>
      </List>
      
    </div>
  );
};

export default LocationalReport;
